import * as React from 'react';
import * as moment from "moment";
import * as DTOS from "../../FeralScan.dtos";
import ModalMessage from '../Common/Modal';
import PaginatedTable, { ISortOption } from '../Data/PaginatedTable/PaginatedTable';
import { FileSortBy, sortFiles } from '../../helpers/graphHelper';
import * as DashboardActionCreators from "../../actions/dashboard.actions";
import FileImageThumbnail from './FileImageThumbnail';

interface IFileListProps {
    className?: string;
    dateTimeFormat: string;
    hidePaginationControls: boolean;
    files: DTOS.FileRecord[];
    filesLoading: boolean;
}

interface IFileListActions {
    onDeleteFile: typeof DashboardActionCreators.deleteFileRequest;
}

type FileListItemProps = IFileListProps & IFileListActions;

interface IFileListState {
    showDeleteModal: boolean;
    deleteFileId: number;
}


class FileList extends React.PureComponent<FileListItemProps, IFileListState> {
    constructor(props, context) {
        super(props, context);

        this.state = { showDeleteModal: false, deleteFileId: undefined };

        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onDeleteHideModel = this.onDeleteHideModel.bind(this);
        this.onDeleteItem = this.onDeleteItem.bind(this);
    }

    onDeleteItem() {
        this.props.onDeleteFile(this.state.deleteFileId);
        this.onDeleteHideModel();
    }

    onDeleteClicked(fileId) {
        this.setState({ showDeleteModal: true, deleteFileId: fileId });
    }

    onDeleteHideModel() {
        this.setState({ showDeleteModal: false, deleteFileId: undefined });
    }

    render() {
        const { className, dateTimeFormat, files, filesLoading, hidePaginationControls } = this.props;

        const SortFilesChoices: ISortOption[] = [
            { value: FileSortBy.ID, label: 'ID' },
            { value: FileSortBy.CREATEDDATE, label: 'Uploaded Date' },
            { value: FileSortBy.CREATEDBY, label: 'Uploaded By UserId' },
        ]
        
        return (
            <div className={className}>
                <PaginatedTable
                    countPerPage={25}
                    data={files}
                    dataColumns={[
                        {
                            label: "Image",
                            dataKey: undefined,
                            render: (f: DTOS.FileRecord) => <FileImageThumbnail file={f}/>
                        },
                        { label: "ID", dataKey: "id" },
                        {
                            label: "Created Date",
                            dataKey: undefined,
                            render: (f: DTOS.FileRecord) => moment(f.createdDate).format(dateTimeFormat)
                        },
                        {
                            label: "Delete",
                            dataKey: undefined,
                            render: (f: DTOS.FileRecord) => <span>
                                <i className="fa fa-trash fa-lg ml-1 clickable" onClick={() => this.onDeleteClicked(f.id)} />
                            </span>
                        },
                    ]}
                    dataLoading={filesLoading}
                    dataSortOptions={SortFilesChoices}
                    hidePaginationControls={hidePaginationControls}
                    sort={sortFiles}
                    tableClassName={"table-sm table-bordered table-hover"}
                />

                <ModalMessage
                    onRequestClose={this.onDeleteHideModel}
                    onNegativeResponse={this.onDeleteHideModel}
                    onPositiveResponse={this.onDeleteItem}
                    isOpen={this.state.showDeleteModal}
                    label="Delete File"
                    message="Are you sure you want to delete this file?"

                    positiveResponseLabel="Delete"
                    positiveResponseClass="btn-danger"
                    negativeResponseLabel="Cancel"
                    negativeResponseClass="btn-secondary"
                />
            </div>
        );
    }
}

export default FileList;
